module.exports = __webpack_public_path__ + "1.0c6348f4.png";